import moment from 'moment-timezone'
import { KeyboardEvent } from 'react'
import { TargetNameTypes } from './Parameters/kpiTypes'

export const PERSISTED_CHANNEL_PREFIX = 'persisted_'

/**
 * this func was created to allow a better comparisson between strings. i clears all the spaces and lowers every case.
 */
export function simplifyString(string: string): string {
    return string
        .toLowerCase()
        .split(' ')
        .join('')
}

/**
 * other than the fact it converts times between timezones, it is important to state that this func was used in the shift cards
 * when receiving the times from the back end
 */
export function convertUTCToLocal(utcTime): string {
    return moment
        .utc(utcTime, hourFormat)
        .local()
        .format(hourFormat)
}

/**
 * other than the fact it converts times between timezones, it is important to state that this func was used in the shift cards
 * when posting the times to the back end
 */
export function convertLocalToUTC(localTime): string {
    return moment(localTime, hourFormat)
        .utc()
        .format(hourFormat)
}

/**
 * used this constant to standerdize the hour format used in the shift cards
 */
export const hourFormat = 'HH:mm'

/**
 * this func was created to handle the fact that, to avoid positioning bugs, lives navs are positioned absolutelly and on top of every thing else
 * so it is necessary to know how big they are so we can position our screens right bellow it and subtract their height when
 * creating a component that has 100vh.
 */
export function getNavsHeight(): number {
    const navElements = document.getElementsByTagName('nav')
    const navsTotalHeight = [...navElements].reduce((acc, el) => {
        const elSpecs = el.getBoundingClientRect()
        if (elSpecs.width > elSpecs.height) {
            acc += elSpecs.height
        }

        return acc
    }, 0)

    return navsTotalHeight
}

/**
 * this func is important to output the url parms as a title
 */
export function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const targetTypes: TargetNameTypes[] = ['drilling', 'tripping', 'casing']

/**
 * this func is used on the params page cell input key down event.
 * it is important to restrict the user from typing characters that the "input type=number" doesn't restrict and are forbidden
 * in our case.
 */
export function onlyAllowPositiveNumbersKeys(event: KeyboardEvent): void | boolean {
    const allowedKeyes = [
        '.',
        'Tab',
        'Backspace',
        'Delete',
        'ArrowUp',
        'ArrowRight',
        'ArrowDown',
        'ArrowLeft',
        'Control',
        'z',
        'x',
        'c',
        'v'
    ]
    if (
        (isNaN(+event.key) && !allowedKeyes.includes(event.key)) ||
        (event.target.value.toString().length === 17 && !allowedKeyes.includes(event.key))
    ) {
        return event.preventDefault()
    }

    return true
}
